import { combineReducers } from '@reduxjs/toolkit';

import pendingChanges from '@helsenorge/core-framework/pending-changes/pending-changes-state';
import hjelpeskuff from '@helsenorge/core-framework/prosesshjelp/hjelpeskuff/hjelpeskuff-state';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import cmsTjenesteTekster from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { createLanguageReducer } from '@helsenorge/framework-utils/language';
import resources from '@helsenorge/framework-utils/resources';

import contentApi from './contentApi';
import tilesApi from './tilesApi';

const rootReducer = combineReducers({
  language: createLanguageReducer([LanguageLocales.NORWEGIAN, LanguageLocales.ENGLISH, LanguageLocales.SAMI_NORTHERN]),
  resources,
  hjelpeskuff,
  pendingChanges,
  cmsTjenesteTekster,
  [contentApi.reducerPath]: contentApi.reducer,
  [tilesApi.reducerPath]: tilesApi.reducer,
});

export default rootReducer;
